module.exports = __webpack_public_path__ + "img/08.6a0b64b8.gif";